import { useCallback, useEffect, useRef, useState } from 'react';

import { useOnWalletLoaded } from '#src/contexts/wallet/walletLoaded/index.tsx';
import {
  WalletTab,
  useWalletDrawerContext,
} from '#src/contexts/walletDrawer/index.tsx';

import { useNeedsCreateEthWallet } from './useNeedsCreateEthWallet';

export const useCreateAndLoadWallet = () => {
  const needsCreateEthWallet = useNeedsCreateEthWallet();
  const subscribeOnWalletLoaded = useOnWalletLoaded();
  const { closeWalletAndDrawer, showWallet, setCurrentTab } =
    useWalletDrawerContext();
  const [initialValueOfNeedsCreateEthWallet] = useState(needsCreateEthWallet);
  const resolveRef = useRef<() => void>(undefined);

  const promise = useCallback(async () => {
    return new Promise<void>(resolve => {
      if (!initialValueOfNeedsCreateEthWallet) {
        resolve();
      } else {
        resolveRef.current = resolve;
        showWallet();
        setCurrentTab(WalletTab.GENERATE_KEYS);
      }
    });
  }, [initialValueOfNeedsCreateEthWallet, setCurrentTab, showWallet]);

  useEffect(
    () =>
      subscribeOnWalletLoaded(() => {
        closeWalletAndDrawer();
        resolveRef.current?.();
      }),
    [subscribeOnWalletLoaded, closeWalletAndDrawer]
  );

  return promise;
};
